import { LosingStreak } from '../components/LosingStreak';

export const Rage = () => {
  return (
    <>
      <LosingStreak />
    </>
  );
};
